import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
  useOutsideClick,
  useToast,
  Divider,
} from '@chakra-ui/react';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { MouseEvent, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';

import CustomToast from 'components/CustomToast';
import { BulkUpdateIndicatorDataInputRequestBody } from 'models/requestBody/modifyIndicatorDataInput.interface';
import { CHART_COLORS } from 'projectConstants';
import {
  fetchIndicatorDetail,
  fetchIndicatorDetailType,
  getDimensionItems,
  getIndicatorDetailTableData,
  getTableView,
  setTableBigView,
} from 'redux/IndicatorPageSlice';
import { getSelectedDriver } from 'redux/PlanPageSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import apiService from 'services';
import PlanPermission from 'container/PlanPermission';

import infoIcon from '../../ItemPage/Icons/infoIcon.svg';

import ItemActions from './ItemActions';
import MonthlyViewTable from './MonthlyViewTable';

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface Properties {
  planPermission: boolean;
  refetchRequest: () => void;
}
const MonthlyView = ({ planPermission, refetchRequest }: Properties) => {
  const dispatch: AppDispatch = useDispatch();
  const toast = useToast();
  const [clearDataInfo, setClearDataInfo] = useState('');
  const indicator: any = useSelector(getIndicatorDetailTableData);

  const dimensionItems = useSelector(getDimensionItems);
  const currentDriver = useSelector(getSelectedDriver);
  const reference = useRef() as React.MutableRefObject<HTMLInputElement>;
  const tab = useSelector(getTableView);
  const baseScenario = useSelector(getBaseScenario);

  useOutsideClick({
    ref: reference,

    handler: (event: any) => {
      if (event.target && !event.target.classList.contains('infoButton')) {
        setClearDataInfo('');
      }
    },
  });

  const accordianButton = () => {
    dispatch(setTableBigView(!tab));
  };
  const toggleInfoPopup = (event: any, id: string) => {
    event.stopPropagation();
    if (clearDataInfo === id) {
      return setClearDataInfo('');
    }
    return setClearDataInfo(id);
  };
  const clearData = async (itemNameId: string) => {
    const requestBody: BulkUpdateIndicatorDataInputRequestBody = {
      request_body: {
        indicator_id: indicator?.id,
        item_name: itemNameId,
        clear: true,
        scenario_id: baseScenario?.id,
      },
    };
    await apiService
      .bulk_update_indicator_data(requestBody)
      .then(() => {
        dispatch(
          fetchIndicatorDetailType({
            currentDriver,
            parameters: {
              dim_id: currentDriver.dimensions[0],
              is_chart_show: false,
              scenario_id: baseScenario?.id,
            },
          }),
        ).then(() =>
          dispatch(
            fetchIndicatorDetail({
              currentDriver,
              parameters: {
                dim_id: currentDriver.dimensions[0],
                scenario_id: baseScenario?.id,
              },
            }),
          ).then(() => {
            refetchRequest();
            return null;
          }),
        );
        toast({
          duration: 2500,
          render: () => <CustomToast title='Cleared data successfully' status='success' />,
        });
      })
      .catch(() => {
        toast({
          duration: 2500,
          render: () => <CustomToast title='No data found' status='error' />,
        });
        return null;
      });
    await setClearDataInfo('');
  };

  return (
    <Box py={4} width={'100%'}>
      <Accordion allowToggle>
        {indicator?.input_display?.index.map((row: any, index: number) => {
          return (
            <>
              {dimensionItems && dimensionItems.items && (
                <>
                  <AccordionItem border='none' key={row}>
                    <AccordionButton onClick={accordianButton}>
                      <Box as='span' flex='1' textAlign='left'>
                        <Tooltip label={row}>
                          <Flex alignItems={'center'}>
                            <Box bg={CHART_COLORS[index]} h='15px' w='15px' mr='2'></Box>
                            <ItemActions
                              row={row}
                              currentDimensionItemIndex={index}
                              refetchRequest={refetchRequest}
                            />
                          </Flex>
                        </Tooltip>
                      </Box>
                      <Menu>
                        <MenuButton
                          width='fit-content'
                          padding='0'
                          as={Button}
                          alignItems='center'
                          position='relative'
                          border='none'
                          height='25px'
                          mr='2px'
                          onClick={(event) => toggleInfoPopup(event, row)}
                        >
                          <Image src={infoIcon} w='20px' height='5px' className='infoButton' />
                        </MenuButton>
                        <MenuList
                          ref={reference}
                          borderRadius='5px'
                          p={'2px 5px 2px 5px'}
                          width='60px'
                          minW='60px'
                        >
                          <MenuItem
                            width='50px'
                            p='5px 5px 5px 5px'
                            _hover={{
                              background: '#EEF2F6',
                              color: 'black',
                            }}
                            cursor={planPermission ? 'not-allowed' : 'pointer'}
                            onClick={
                              planPermission
                                ? (event: MouseEvent) => {
                                    event.stopPropagation();
                                  }
                                : (event: MouseEvent) => {
                                    event.stopPropagation();
                                    clearData(row);
                                  }
                            }
                          >
                            <Text color='black' fontSize={'xs'}>
                              Clear
                            </Text>
                          </MenuItem>
                        </MenuList>
                      </Menu>
                      <AccordionIcon />
                    </AccordionButton>

                    <AccordionPanel
                      pb={4}
                      alignItems={'center'}
                      justifyContent={'center'}
                      className='horizontal_scroll_monthly'
                      overflowX={'scroll'}
                    >
                      <MonthlyViewTable itemName={row} refetchRequest={refetchRequest} />
                    </AccordionPanel>
                  </AccordionItem>
                  <Divider orientation='horizontal' />
                </>
              )}
            </>
          );
        })}
      </Accordion>
    </Box>
  );
};
export default PlanPermission(MonthlyView);
